export default __webpack_public_path__ + "4fd2a9780cbc10c94e185b5acdd61104.pdf";